import React, { memo } from 'react';
import styled from 'styled-components';
import { useSpring, animated } from 'react-spring';
import { line } from 'd3-shape';

const Line = styled(animated.path)`
  stroke-width: 2;
  stroke: ${(p) => p.color};
  fill: none;
`;

const LineComp = ({ color = '#ddd', data = [], xScale, yScale }) => {
  const generator = line()
    .x((d) => xScale(d.x))
    .y((d) => yScale(d.y));

  const path = useSpring({
    d: generator(data),
  });

  return (
    <g>
      <Line clipPath="url(#chartClip)" d={path.d} color={color} />
    </g>
  );
};

export default memo(LineComp);
